module.exports = __webpack_public_path__ + "assets/95776e715460997a781f45549e77da6d.png";